import * as React from 'react';

import {Button} from 'shells/button/button';
// @ts-expect-error - imported from .js/.jsx file
import {TickCircleIcon} from 'shells/icon/svg/tick-circle-icon';

import styles from './complete-task-button.module.css';

type Props = {
    isActive: boolean;
    disabled?: boolean;
    onClick: () => any;
};

type State = {
    isActive: boolean;
};

export class CompleteTaskButton extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isActive: props.isActive,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (this.props.isActive !== nextProps.isActive) {
            this.setState({isActive: nextProps.isActive});
        }
    }

    render() {
        const styleName = this.state.isActive ? styles['complete--active'] : styles.complete;

        return (
            <div className={styles['complete-task-button']}>
                <Button
                    variant='secondary'
                    size='big'
                    // @ts-expect-error
                    disabled={this.props.disabled}
                    onClick={this.handleClick}
                >
                    <div className={styleName}>
                        <TickCircleIcon size={15} />
                        Complete
                    </div>
                </Button>
            </div>
        );
    }

    handleClick = () => {
        // Immediately update state so we don't have a janky double transition.
        this.setState((prevState) => ({isActive: !prevState.isActive}));
        this.props.onClick();
    };
}
